import { Button } from 'react-bootstrap';
import { EXPORTING_PLACEHOLDER } from '../constants/uiText';

type Props = {
  onExport: () => void;
  disabled?: boolean;
  exporting?: boolean;
  label?: string;
};

const ExportCsvButton = ({ onExport, disabled, exporting = false, label = 'Export CSV' }: Props) => {
  return (
    <Button onClick={onExport} disabled={disabled}>
      {exporting ? EXPORTING_PLACEHOLDER : label}
    </Button>
  );
};

export default ExportCsvButton;
